import { FileSpreadsheetIcon } from 'lucide-react'

import { Body } from './Body'

import type { Announcement } from '../types'

export const advancedExportsAnnouncement: Announcement = {
  version: '3.0.0',
  date: '2026-08-11',
  title: 'Exportación Avanzada de Reportes',
  summary: 'Cinco reportes de la automotora, descargables en planillas Excel listas para trabajar.',
  icon: FileSpreadsheetIcon,
  Body,
}
